import { render, staticRenderFns } from "./result.vue?vue&type=template&id=29808f5f&scoped=true&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&id=29808f5f&lang=scss&scoped=true&"
import style1 from "./result.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29808f5f",
  null
  
)

export default component.exports